import {
  removeRefreshToken,
  removeAccessToken,
} from '$extensionSrc/serverClient'

import { setUser } from './user'
import { setWelcomed } from './welcomed'
import { removeAnonymousUserIdCookie } from '../../metrics/cookies'

export async function logout(): Promise<void> {
  // Note: setting user to null triggers the background script
  // local storage listener and has other side effects
  await setUser(null)
  await removeAccessToken()
  await removeRefreshToken()
  await removeAnonymousUserIdCookie()
  await setWelcomed(false)
}
